import React, { useEffect, useState } from 'react';
import { PieChart } from '@mui/x-charts/PieChart';
import { BarChart } from '@mui/x-charts/BarChart';
import { api } from '../helpers';
import { MAIN_COLOR, path } from '../constants';
import Loader from '../Components/Loader';

export default function Dashboard() {
  const [status, setStatus] = useState({})
  const [selectedBranch, setSelectedBranch] = useState(null)
  const [branches, setBranches] = useState([])
  const [loading, setLoading] = useState(true)

  const fetchBranches = () => {
    api.get(path.branch).then(response => {
      let data = response.data
      if (data.success) {
        let brOptions = data.branches
        setBranches(brOptions)
        setSelectedBranch(brOptions[0])
      }
    })
  }
  const getPackageDistribution = () => {
    let packages = status.branch_packages
    packages = packages.map(p => ({
      id: p.id,
      value: status.week_events?.filter(w => w.packageId == p.id).length,
      label: p.name
    }))
    return packages
  }

  const getWeekEvents = () => {
    let events = [0, 1, 2, 3, 4, 5, 6].map(day => {
      return status.week_events?.filter(e => e.day == day).length
    })
    return events
  }


  const getTotal = (nop, pricing, add, dis) => {
    let price = pricing?.find(p => {
      if (nop <= p.max && nop >= p.min) return true
    })
    let total = ((nop * parseInt(price.value)) + parseInt(add)) - parseInt(dis)
    return total
  }

  const getWeekRevenue = () => {
    const revenues = [0, 1, 2, 3, 4, 5, 6].map(day => {
      let events = status.week_events.filter(e => e.day == day)
      let revenue = events.reduce((acc, cu) => {
        let pkg = status.branch_packages?.find(p => p.id == cu.packageId)
        let total = getTotal(cu.num_of_people, pkg.prices, cu.additional_price, cu.discount_amount)
        return total + acc
      }, 0)
      return revenue
    })

    return revenues
  }

  const getTodayRevenue = () => {
    let revenue = status.today_events.reduce((acc, cu) => {
      let pkg = status.branch_packages?.find(p => p.id == cu.package.id)
      let total = getTotal(cu.num_of_people, pkg.prices, cu.additional_price, cu.discount_amount)
      return total + acc
    }, 0)
    return revenue
  }

  const getLastMonthRevenue = () => {
    let revenue = status.month_events.reduce((acc, cu) => {
      let pkg = status.branch_packages?.find(p => p.id == cu.packageId)
      let total = getTotal(cu.num_of_people, pkg.prices, cu.additional_price, cu.discount_amount)
      return total + acc
    }, 0)
    return revenue
  }

  useEffect(() => {
    fetchBranches()
  }, [])

  const fetchStatus = async () => {
    let response = await api.get(path.status + '?branchId=' + selectedBranch.id)
    if (response.data?.success) {
      setStatus(response.data?.status)
      setLoading(false)
    }
    
  }

  useEffect(() => {
    if (selectedBranch) fetchStatus()
  }, [selectedBranch])

  return loading ? <div className='flex flex-1 flex-col bg-white gap-2 justify-center items-center'>
    <p className='text-black text-lg font-bold'>{'Loading Reports'}...</p>
    <Loader loading={true} color={MAIN_COLOR} />
  </div> : (
    <div className='flex-1 flex flex-col bg-[#eeeeee] p-6 overflow-y-auto'>
      <div className='grid grid-cols-3 gap-6 max-md:grid-cols-1'>
        <div className='p-4 bg-white rounded-md shadow-lg'>
          <h1 className='text-[25px] text-center mb-6'>Total Events</h1>
          <h1 className='text-[40px] text-center'>{status?.total_events?.toLocaleString()}</h1>
        </div>
        <div className='p-4 bg-white rounded-md shadow-lg'>
          <h1 className='text-[25px] text-center mb-6'>Total Agents</h1>
          <h1 className='text-[40px] text-center'>{status?.total_agents?.toLocaleString()}</h1>
        </div>
        <div className='p-4 bg-white rounded-md shadow-lg'>
          <h1 className='text-[25px] text-center mb-6'>Total Branches</h1>
          <h1 className='text-[40px] text-center'>{status?.total_branches?.toLocaleString()}</h1>
        </div>
      </div>

      <div className='flex items-center gap-4 my-8'>
        <p className='text-[16px] uppercase font-bold'>Report By Branch</p>
        <div className='flex rounded-[30px] bg-[#00000030] overflow-hidden shadow-md'>
          {branches.map(branch => (
            <div onClick={() => setSelectedBranch(branch)} className={'px-6 py-2 max-md:px-3 flex-1 items-center flex cursor-pointer hover:scale-[1.1] transition-all ' + (selectedBranch?.id == branch.id && 'bg-[#00000095]')}>
              <h2 className={'text-black text-sm max-md:text-xs  whitespace-nowrap font-bold select-none ' + (selectedBranch?.id == branch.id && 'text-white')}>{branch.name}</h2>
            </div>
          ))}
        </div>
      </div>

      <div className='grid grid-cols-2 mt-10 max-md:grid-cols-1'>
        <div className='flex items-center gap-4 justify-center flex-col max-md:w-[200px] max-md:pl-12'>
          <p>This Week Package Schedule Distribution by Branch</p>
          <Pie data={getPackageDistribution()}/>
        </div>
        <div className='flex items-center flex-col justify-center max-md:mt-6'>
          <p>This week Events by Branch</p>
          <Bars data={getWeekEvents()} />
        </div>
      </div>
      <div className='flex flex-col mt-16'>
        <h2 className='self-center text-2xl font-bold border-b-[1px] border-b-[#00000080] pb-[2px]'>Financial</h2>
        <div className='grid grid-cols-3 gap-6 max-md:grid-cols-1 mt-6'>
          <div className='flex items-center flex-col justify-center max-md:mt-6'>
            <p>This week revenue distribution</p>
            <Bars color data={getWeekRevenue()} />
          </div>
          <div className='p-4 bg-white rounded-md shadow-lg'>

            <h1 className='text-[25px] text-center mb-6'>Today Estimated Revenue</h1>
            <h1 className='text-[40px] text-center'>ETB {getTodayRevenue()?.toLocaleString()}</h1>
          </div>
          <div className='p-4 bg-white rounded-md shadow-lg'>
            <h1 className='text-[25px] text-center mb-6'>Last Month Estimated Revenue</h1>
            <h1 className='text-[40px] text-center'>ETB {getLastMonthRevenue()?.toLocaleString()}</h1>
          </div>
        </div>

      </div>
    </div>
  )
}

function Pie({data}) {
  return (
    <PieChart
      series={[
        {
          data,
        },
      ]}
      width={300}
      height={200}
    />
  );
}

function Bars({ color, data }) {
  return (
    <BarChart
      xAxis={[{ scaleType: 'band', data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'] }]}
      series={[{ data, color: color ? '#4CAF50' : '#007aff' }]}
      width={500}
      height={300}
    />
  );
}